/*
 * @Author: 阿宇 969718197@qq.com
 * @Date: 2024-11-19 18:27:06
 * @LastEditors: 阿宇 969718197@qq.com
 * @LastEditTime: 2025-03-20 15:11:07
 * @Description: 国际化
 */
import VueI18n from "vue-i18n";
import Vue from "vue";
import messages from "./locale";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'CN',
  fallbackLocale: 'CN',
  messages,
  legacy: false,
});
export default i18n;